import IconButton from '@material-ui/core/IconButton';
import { FileUpload } from '@/component/common/UploadFiles';
import Utils from '@/common/utils/utils';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Constant from '@/common/constant/Constant';
import {
    createNewTicketAPI, saveDraftTicketAPI,
} from '@/service/ticketService';
import { copyFileOfTicketDraftTo, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { getFilteredAndSortedForms } from './TicketHandler';
import { getUserListInProject, getProjectById } from '@/service/projectService';
import { isInputFormValue, submitOnchangeForm } from './HelpdeskCreateTicketHandler';
import { I18n } from 'aws-amplify';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { getAllCustomerUsers } from './NoticeTicketHandler';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';

export const onSelectGuestUser = (userIdSelected, argsAll, guestUserListByProject, isFirstRender = false) => {
    let userObj = guestUserListByProject.find((obj) => {
        return obj.id === userIdSelected;
    });
    if (Utils.isEmptyObject(userObj)) {
        return;
    }

    argsAll.setGuestUserSelected(userObj);
    if (isFirstRender) return;
    argsAll.setIsEdited(true);
};

export const handleDeleteFile = (index, fileUploadList, argsAll) => {
    let newFileUploadList = fileUploadList;
    newFileUploadList.splice(index, 1);
    argsAll.setValue('fileUploadList', newFileUploadList);
    argsAll.setFileUploadList([...newFileUploadList]);
    // setToggleReload(!toggleReload);
};

export const renderImage = (fileUploadList, argsAll) => {
    let contentChatList = [];
    fileUploadList.forEach((fileUploadInfor, index) => {
        let item = { content: fileUploadInfor.file.name, fileSize: fileUploadInfor.file.size };
        contentChatList.push(
            <li>
                <FileUpload
                    fileUploadInfor={fileUploadInfor}
                    fileUploading={argsAll.fileUploading}
                    chatPost={item}
                ></FileUpload>
                <div className="lstName-item">
                    <IconButton
                        onClick={() => handleDeleteFile(index, fileUploadList, argsAll)}
                        className="itemDelete"
                    >
                        <img src="/assets/image/dustbox_b.png" alt="" />
                    </IconButton>
                </div>
            </li>
        );
    });
    return contentChatList;
};

export const onSubmitCreateDelegateTicket = async (
    argsAll,
    formData,
    userDetail,
    panelId,
    panelType,
    tabId,
    corporationDetail,
    guestProjectSelected,
    fieldListData
) => {
    argsAll.setIsLoading(true);

    const affiliationOrganization = corporationDetail.id;
    const affiliationProject = localStorageUtil.getSelectedProjectId();
    
    // Validate when project type is deskOnPublicOff
    const isDeskOnPublicOffSendDraft = Utils.isPrivateDesk(argsAll.projectInuseDetail) &&
        argsAll?.detailTicket?.public === Constant.TICKET_PUBLIC.DRAFT;
        
    if (isDeskOnPublicOffSendDraft) {
        let isCanNotSendDraft = guestProjectSelected.type === Constant.PROJECT_TYPE.CUSTOMER ||
            guestProjectSelected.affiliationOrganization !== affiliationOrganization;

        if (isCanNotSendDraft) {
            argsAll?.setIsCanNotSendTicketWhenDeskOnPublicOff(true);
            argsAll?.setIsLoading(false);
            return;
        }
    }

    let guestUserId;
    if (formData.guestUserId) {
        guestUserId = formData.guestUserId;
    } else if (!Utils.isEmptyObject(argsAll.guestUserSelected)) {
        guestUserId = argsAll.guestUserSelected.id;
    }

    let customer;
    if (Utils.isProjectGuest(guestProjectSelected) || guestProjectSelected.type === Constant.PROJECT_TYPE.GENERAL) {
        customer = guestProjectSelected.id;
    } else {
        customer = guestUserId;
    }

    const creator = userDetail.id;
    const proxyCreator = userDetail.id;
    const proxiedUser = guestUserId ? guestUserId : '';
    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }
    const fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    formData.affiliationOrganization = affiliationOrganization;
    const uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };
  
    const requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            outline: formData.outline,
            corporationOrigin: guestProjectSelected.affiliationOrganization,
            description: formData.description,
            createUserId: creator,
            projectOrigin: guestProjectSelected.id,
            type: argsAll?.selectedForm,
            projectTarget: [localStorageUtil.getSelectedProjectId()],
            corporationTarget: corporationDetail.id,
            ticketType: Constant.TICKET_TYPE.DELEGATE,
            delegatedUserId: guestUserId,
            affiliationOrganization,
            affiliationProject,
            customer,
            creator,
            proxiedUser,
            proxyCreator,
            status,
            fields,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ...draftTicketInfo

        }
    };

    const newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            // Reload
            argsAll.setIsOpenModalReloadPage(true);
        }
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_DELEGATE,
        formId: argsAll?.selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }
    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    argsAll.setIsLoading(false);
    
    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: {
            id: argsAll.corporationDetail.id
        },
        rootProjectDetail: {
            id: argsAll.projectInuseDetail.id
        },
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            ticketType: Constant.TICKET_TYPE.QA
        },
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }
    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);
    if (!tabId) {
        tabId = argsAll.ticketId;
    }
    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });

    argsAll.enqueueSnackbar(I18n.get('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

    return newTicket;
};



/**
 * getFormOfProjectDelegate
 * @param {*} argsAll 
 */
export const getFormOfProjectDelegate = (argsAll) => {
    argsAll.setFiledListData([]);
    // const formOfProjectList = await getFormListByProject(
    //     argsAll.API,
    //     argsAll.corporationDetail.id,
    //     argsAll.projectInuseDetail.id
    // );

    const formOfProjectList = argsAll.formList;

    let listFormQaOfProject = getFilteredAndSortedForms(
        formOfProjectList,
        argsAll.projectInuseDetail.id,
        Constant.FORM_TYPE.FORM_REQ_QA
    );

    argsAll.setFormList(listFormQaOfProject);
    argsAll.setSelectedForm('');
    argsAll.setFiledListData([]);
};


/**
 * onSelectProjectDelegate
 * @param {*} projectIdSelected 
 * @param {*} argsAll 
 * @returns 
 */
export const onSelectProjectDelegate = async (projectIdSelected, argsAll, isClearData = true) => {
    if (!projectIdSelected || projectIdSelected === 0 || projectIdSelected === '') {
        argsAll.setGuestProjectSelected({});
        argsAll.setGuestUserSelected({});
        argsAll.setGuestUserListByProject([]);
        return;
    }

    if (isClearData) {
        argsAll.setGuestUserSelected({});
    }

    argsAll.clearErrors('projectId');
    argsAll.clearErrors('guestUserId');
    let selectedGuestProjectDetail = argsAll.guestProjectList.find(project => project.id === projectIdSelected)
    if (!selectedGuestProjectDetail || Utils.isEmptyObject(selectedGuestProjectDetail)) {
        selectedGuestProjectDetail = await getProjectById(argsAll.API, projectIdSelected);
    }

    if(!Utils.isEmptyObject(selectedGuestProjectDetail)){
        argsAll.setGuestProjectSelected(selectedGuestProjectDetail);
        argsAll.setValueCreateTicket('projectId', selectedGuestProjectDetail.id);
        argsAll.setValueCreateTicket('corporationOrigin', selectedGuestProjectDetail.affiliationOrganization);
        if (isClearData) {
            argsAll.setIsEdited(true);
        }
        argsAll.setIsLoading(true);

        let customerUserList = await getCustomerUserInCustomerProject(
            projectIdSelected,
            selectedGuestProjectDetail.type,
            argsAll
        );
        argsAll.setGuestUserListByProject(customerUserList);
        if (isClearData) {
            argsAll.setIsLoading(false);
        }

        return customerUserList;
    }
};


/**
 * getCustomerUserInCustomerProject
 * @param {*} customerProject 
 * @param {*} type 
 * @param {*} argsAll 
 * @returns 
 */
const getCustomerUserInCustomerProject = async (customerProject, type, argsAll) => {
    
    if (Utils.isEmptyObject(customerProject)) {
        return [];
    }

    let customerUserList
    if(type === Constant.PROJECT_TYPE.CUSTOMER ){
        const customerUserOfProject = await getAllCustomerUsers(argsAll.API, argsAll.projectInuseDetail);
        customerUserList = customerUserOfProject.allCustomerUser
    }else{
        customerUserList = await getUserListInProject(argsAll.API, customerProject);
    }
    
    if (Utils.isEmptyArray(customerUserList)) {
        return [];
    }
    let userList = [];
    customerUserList?.forEach(projectUser => {
        if (projectUser.id !== argsAll.userDetail.id && projectUser.active === Constant.ACTIVE_FLAG.ACTIVE) {
            projectUser.label = `${Utils.getFullNameOfUser(
                Constant.LANGUAGE_TYPE.JP,
                projectUser
            )}`;
            userList.push(projectUser);
        }
    });

    userList = sortLabelByDictionaryASC(userList);

    return userList;
}


/**
 * handleOnchangeFormDelegateAndTask
 * @param {*} e 
 * @param {*} argsAll 
 * @returns 
 */
export const handleOnchangeFormDelegateAndTask = async (e, argsAll) => {
    let currentSelectedForm = '';
    if (e.target.value) {
        currentSelectedForm = e.target.value;
    } else if (e.target.dataset.value) {
        currentSelectedForm = e.target.dataset.value;
    }

    if (
        !currentSelectedForm ||
        (currentSelectedForm === argsAll.selectedForm &&
            (argsAll.createTicketType !== Constant.TICKET_TYPE.EMAIL ||
                (argsAll.createTicketType === Constant.TICKET_TYPE.EMAIL && argsAll.isDraft)))
    ) {
        return;
    }

    if (isInputFormValue(argsAll)) {
        argsAll.setIsConfirmChangeForm(true);
        argsAll.setSelectedFormChange(currentSelectedForm);
    } else {
        submitOnchangeForm(currentSelectedForm, argsAll);
    }

    argsAll.setIsOpenSelectForm(false);
};


/**
 * handleCreateDelegateTicketSubmit
 * @param {*} formData 
 * @param {*} argsAll 
 * @returns 
 */
export const handleCreateDelegateTicketSubmit = (formData, argsAll) => {
    if(Utils.isEmptyString(formData.projectId) && Utils.isEmptyObject(argsAll.guestProjectSelected)){
        argsAll.setErrorCreateTicket(
            'projectId',
            { type: 'manual', message: I18n.get('COMM01MSG11') },
            { shouldFocus: false }
        );
        return; 
    }

    if (argsAll.guestProjectSelected.type === Constant.PROJECT_TYPE.CUSTOMER || argsAll.guestProjectSelected.type === Constant.PROJECT_TYPE.BASE ) {
        let guestUserId;
        if (formData.guestUserId) {
            guestUserId = formData.guestUserId;
        } else if (!Utils.isEmptyObject(argsAll.guestUserSelected)) {
            guestUserId = argsAll.guestUserSelected.id;
        }

        if (Utils.getPrefixOfId(guestUserId) !== 'user') {
            argsAll.setErrorCreateTicket(
                'guestUserId',
                { type: 'manual', message: I18n.get('COMM01MSG11') },
                { shouldFocus: false }
            );
            return;
        }
    }

    if (Utils.isEmptyString(argsAll.selectedForm)) {
        argsAll.setErrorCreateTicket(
            'selectedForm',
            { type: 'manual', message: I18n.get('COMM01MSG11') },
            { shouldFocus: false }
        );
        return;
    }

    if (Utils.isEmptyArray(argsAll.fieldListData)) {
        return;
    }

    return onSubmitCreateDelegateTicket(
        argsAll,
        formData,
        argsAll.userDetail,
        argsAll.panelId,
        argsAll.panelType,
        argsAll.tabId,
        argsAll.corporationDetail,
        argsAll.guestProjectSelected,
        argsAll.fieldListData,
    );
};


// sort list by alphabetical order
export const sortLabelByDictionaryASC = (list) => {
    if (Utils.isEmptyArray(list)) {
        return [];
    }

    return list.sort((a, b) => {
        let nameA = a.label;
        let nameB = b.label;
        return nameA.localeCompare(nameB);
    });
}

export const onSaveDraftDelegateTicketHandler = async (formData, argsAll) => {
    argsAll.setIsLoading(true);
    
    const affiliationOrganization = argsAll.corporationDetail.id;
    const affiliationProject = localStorageUtil.getSelectedProjectId();
    let customer;
    let guestUserId;

    if (formData.guestUserId) {
        guestUserId = formData.guestUserId;
    } else if (!Utils.isEmptyObject(argsAll.guestUserSelected)) {
        guestUserId = argsAll.guestUserSelected.id;
    }

    let guestProjectSelected = argsAll.guestProjectSelected;
    if (Utils.isProjectGuest(guestProjectSelected) || guestProjectSelected.type === Constant.PROJECT_TYPE.GENERAL) {
        customer = guestProjectSelected.id;
    } else {
        customer = guestUserId;
    }

    const creator = argsAll.userDetail.id;
    const proxyCreator = argsAll.userDetail.id;
    const proxiedUser = guestUserId ? guestUserId : '';
    let status = '';
    const statusField = argsAll.fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }
    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    const uploadS3Result =await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    formData.affiliationOrganization = affiliationOrganization;

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };
   
    const requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            outline: formData.outline,
            corporationOrigin: guestProjectSelected.affiliationOrganization,
            description: formData.description,
            createUserId: creator,
            projectOrigin: guestProjectSelected.id,
            type: argsAll?.selectedForm,
            projectTarget: [affiliationProject],
            corporationTarget: affiliationOrganization,
            ticketType: Constant.TICKET_TYPE.DELEGATE,
            delegatedUserId: proxiedUser,
            affiliationOrganization,
            affiliationProject,
            customer,
            creator,
            proxiedUser,
            proxyCreator,
            status,
            fields,
            fileListSuccess: uploadS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadS3Result?.suffixOfAttachments),
            ...draftTicketInfo

        },
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            // Reload
            argsAll.setIsLoading(false);
            argsAll.setIsOpenModalReloadPage(true);
        }
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_DELEGATE,
        formId: argsAll?.selectedForm,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);
    argsAll.setIsLoading(false);
    return newTicket;
};


